/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_SectionInputs */



/**
* | output |
* | --- |
* | "Feedback" |
*
* @param {Feedback_SectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_section = /** @type {((inputs?: Feedback_SectionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_SectionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Commentaires")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comentarios")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Feedback")
	if (locale === "it") return /** @type {LocalizedString} */ ("Feedback")
	return /** @type {LocalizedString} */ ("Feedback")
});